import { OverlayIcon } from '@components/GateFigure';
import { Wifi, Wifi1Bar, Wifi2Bar } from '@mui/icons-material';
import { useEffect, useState } from 'react';

const iconSequence = [Wifi, Wifi1Bar, Wifi2Bar];

const stepInterval = 1000;

export const InQueueIcon: OverlayIcon = ({ canAnimate, ...props }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (canAnimate) {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % iconSequence.length);
      }, stepInterval);

      return () => {
        clearInterval(interval);
      };
    }
  }, [canAnimate]);

  const CurrentIcon = iconSequence[index];

  return <CurrentIcon {...props} />;
};
